import moment from "moment";
import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // icons

const Receipts = ({ receiptDetails }) => {

    return (
        <div className='gridshad mt-2 mb-3'>
            <div className="table-container" style={{ overflowX: "auto", height: "auto" }}>
                <table>
                    <thead className="dynoTable">
                        <tr>
                            <th>Voucher No</th>
                            <th>Receipt Date</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Payment Method</th>
                            <th>Cheque No</th>
                            <th>Cheque Date</th>
                            <th>Drawn Bank</th>
                            <th>Dr Account</th>
                        </tr>
                    </thead>

                    {/* Rent Section */}
                    <tbody>
                        {Array.isArray(receiptDetails) &&
                            receiptDetails?.map((data, index) => (
                                <tr key={index}>
                                    <td><input className="p-1" value={data?.VoucherNo} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={moment(data?.PaymentDate).format("DD-MMM-YYYY")} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={data?.Description} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={data?.Amount} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={data?.PaymentMethod} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={data?.ChequeNo} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={moment(data?.ChequeDate).format("DD-MMM-YYYY")} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={data?.DrawnOnBank} disabled style={{ width: "100%" }} /></td>
                                    <td><input className="p-1" value={data?.DebitAccount} disabled style={{ width: "100%" }} /></td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Receipts;